import React from "react";

import EditSuggestion from "../../components/Suggestions/EditSuggestion";

const EditSuggestionPage: React.FC = () => {
  return <EditSuggestion />;
};

export default EditSuggestionPage;
